import './App.css'
import AuthState from './context/authentication/authState'
import ProductosState from './context/productos/productosState'
import Navigator from './navigator/Navigator'


function App() {

  return (
    <AuthState>
      <ProductosState>
        <Navigator />
      </ProductosState>
    </AuthState>
  )
}

export default App
